import loadable from '@loadable/component'

export default [
  {
    path: '/game/EggMachine',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-game-EggMachine" */ '~/pages/game/EggMachine'
        )
    ),
  },
  {
    // 下注记录
    path: '/game/EggMachine/Rank',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-game-EggMachine-Rank" */ '~/pages/game/EggMachine/SubPages/Rank'
        )
    ),
  },

  {
    // 下注记录
    path: '/game/EggMachine/Records',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-game-EggMachine-Records" */ '~/pages/game/EggMachine/SubPages/Records'
        )
    ),
  },
  {
    // 任务记录
    path: '/game/EggMachine/Missions',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-game-EggMachine-Missions" */ '~/pages/game/EggMachine/SubPages/Missions'
        )
    ),
  },
]
